var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.2292C1 16.4118 2.26428 19.4641 4.51472 21.7145C6.76516 23.965 9.8174 25.2292 13 25.2292C16.1826 25.2292 19.2348 23.965 21.4853 21.7145C23.7357 19.4641 25 16.4118 25 13.2292C25 10.0467 23.7357 6.9944 21.4853 4.74397C19.2348 2.49353 16.1826 1.22925 13 1.22925C9.8174 1.22925 6.76516 2.49353 4.51472 4.74397C2.26428 6.9944 1 10.0467 1 13.2292V13.2292Z",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 15.629C10.5996 16.1036 10.7404 16.5676 11.0041 16.9623C11.2678 17.357 11.6426 17.6646 12.0812 17.8463C12.5197 18.0279 13.0023 18.0754 13.4678 17.9828C13.9334 17.8902 14.361 17.6617 14.6967 17.326C15.0323 16.9904 15.2609 16.5627 15.3535 16.0972C15.4461 15.6316 15.3986 15.1491 15.2169 14.7105C15.0353 14.272 14.7277 13.8971 14.333 13.6334C13.9383 13.3697 13.4743 13.229 12.9996 13.229C12.5249 13.229 12.0609 13.0882 11.6662 12.8245C11.2716 12.5608 10.964 12.1859 10.7823 11.7474C10.6006 11.3089 10.5531 10.8263 10.6457 10.3607C10.7383 9.89519 10.9669 9.46755 11.3026 9.1319C11.6382 8.79625 12.0658 8.56768 12.5314 8.47507C12.9969 8.38247 13.4795 8.42999 13.9181 8.61165C14.3566 8.7933 14.7314 9.10091 14.9951 9.49559C15.2589 9.89027 15.3996 10.3543 15.3996 10.829",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.001 6.82935V8.42935",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.001 18.0295V19.6295",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.62d0d7bfca63c2de1b56ef3b004a1773.svg";
export { ForwardRef as ReactComponent };